<script>
    import Loader from './Components/Loader.svelte'
    import SortableTable from './Components/SortableTable.svelte';
    import AssessmentTypeModel from './Models/assessmentTypeModel'
    import AssessmentTypeNav from './Components/AssessmentTypeNav.svelte';
    import {tables} from './lib/tables';
    import {forms} from './lib/forms';
    import {addFormModal} from './Forms/ModalFormManager.svelte';
    import { notifier } from '@beyonk/svelte-notifications'

    export let params;

    let assessment_type_model, assessment_type;

    function loadAssessmentType(assessment_type_id) {
        assessment_type_model = new AssessmentTypeModel(params.id);
        assessment_type = assessment_type_model.store;
    }

    function addPolicy() {
        addFormModal({
            fields: forms['policy'],
            title: "Add Policy"
        }).then((formData) => {
            assessment_type_model.addPolicy(formData).then(() => {
                notifier.success("Policy Added");
            });
        })
    }

    function deletePolicy(policy) {
        assessment_type_model.deletePolicy(policy).then(() => {
            notifier.success("Policy Deleted");
        });
    }

    function editPolicy(policy) {
        addFormModal({
            fields: forms['policy'],
            title: "Edit Policy",
            data: policy
        }).then((formData) => {
            assessment_type_model.savePolicy(formData).then(() => {
                notifier.success("Policy Updated");
            })
        })
    }

    $: loadAssessmentType(params.id);
</script>

<Loader loading={!$assessment_type}>
    <div class="container viewport is-fluid">
        <div class="columns">
            <div class="column is-3">
                <AssessmentTypeNav assessment_type_id={params.id}></AssessmentTypeNav>
                <h1 class="title is-1">{$assessment_type.details.name}</h1>
            </div>
        </div>
        <div class="policies">
            <h2 class="title is-2">Policies</h2>
            <SortableTable
                tableData={$assessment_type.policies}
                sortFields = {tables['assessmentPolicies']}
                actionsWidth=250
            >
                <div slot="filterActions">
                    <span class="button is-info is-right" on:click={addPolicy}>Add Policy</span>
                </div>
                <div slot="footerActions">
                    <span class="button is-info is-right" on:click={addPolicy}>Add Policy</span>
                </div>
                <div slot="rowActions" let:row={policy}>
                    <div class="buttons is-right">
                        <span class="button is-info" on:click={() => editPolicy(policy)}>Edit Policy</span>
                        <span class="button is-danger" on:click={() => deletePolicy(policy)}>Delete Policy</span>
                    </div>
                </div>
            </SortableTable>
        </div>
    </div>
</Loader>

<style>
    .columns {
        margin: 0;
    }

    .policies {
        padding: 0 .75rem;
    }
</style>